import * as Sentry from '@sentry/react';

import { truncToPlace } from 'bundles/primitive-formatting/utils/numberUtils';

/**
 * Function handles for returning grades as a percentage value and rounds it's decimal to 2 digits.
 */
export function gradePercentageValue({ grade }: { grade?: number }): string {
  let result = '--';
  if (grade === undefined) {
    return result; // potentially still rendering, or undefined is intended from above this component.
  } else if (isNaN(grade)) {
    // log this case so we know when it happens
    // captureException should always take an error as it's first argument.
    // this will send the error message text to Sentry.
    // it also supports a second argument of additional context.
    Sentry.captureMessage('TypeError: GradeValue has recieved NaN instead of a number', {
      extra: { type: typeof grade, expected: 'number' },
      level: 'fatal',
      tags: { source: 'numberFormats' },
    });
    return result;
  } else {
    const gradeValueTwoDecimal = truncToPlace(grade * 100, 2);
    const fixedDigitCount = gradeValueTwoDecimal % 1 === 0 ? 0 : 2;
    result = gradeValueTwoDecimal.toFixed(fixedDigitCount);
  }

  return result;
}
